import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HowDoesItWorkComponent } from './how-does-it-work/how-does-it-work.component';
import { IntroComponent } from './intro/intro.component';
import { WhoAreWeComponent } from './who-are-we/who-are-we.component';
import { InstallationComponent } from './installation/installation.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { } from './how-does-it-work/how-does-it-work.component';


const routes: Routes = [
	{ path: '', redirectTo: '/intro', pathMatch: 'full'},
	{ path: 'intro', component: IntroComponent},
	{ path: 'how-does-it-work', component: HowDoesItWorkComponent},
	{ path: 'who-are-we', component: WhoAreWeComponent},
	{ path: 'installation', component: InstallationComponent},
	{ path: 'contact-us', component: ContactUsComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
